import type Talk from 'talkjs'

import { type Shipment } from 'shipments/domain/Shipment'

export type UserOptions = Talk.UserOptions

export type Participant = {
  name?: string
  type: string
  uuid: string
}

export type Session = Talk.Session

export type ConversationParticipant = {
  name?: string
  type: string
  uuid: string
}

export type Chat = {
  uuid: string
  subject: string
  lastMessage?: {
    createdAt?: string
    text?: string
    isUnread?: boolean
  }
  participants: ConversationParticipant[]
  type: string
  context?: ChatContext
}

export type Contact = {
  uuid: string
  name: string
  email: string
  type?: string
}

export type Conversation = {
  uuid: string
  subject: string
  participants: ConversationParticipant[]
  type: string
}

export type ChatContactInfo = {
  name?: string
  email: string
  uuid: string
  phone?: string
  talkJsToken: string
}

export type CarrierEmployee = {
  contact?: {
    account: {
      uuid: string
      name: string
    }
  }
}

export type ChatContact = {
  account: {
    uuid: string
    name: string
    email: string
    type: string
  }
}

export type ChatContext = {
  source: 'shipper_guide'
  entityName: 'rate'
  entityIdentifier: string
}

export type ListChatSource = {
  entityIdentifier: string
  inviteToken?: string
  shipper: {
    name: string
    email: string
  }
  subject: string
  subtitle: string
}

export function mapShipmentToShipperContact(shipment: Pick<Shipment, 'managedBy'>) {
  if (!shipment.managedBy) {
    throw new Error('Shipment managedBy is required')
  }

  return {
    email: shipment.managedBy.contactEmail,
    name: shipment.managedBy.contactName,
  }
}
